/*jslint white: true, nomen: true */
/*global angular */
(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formComponentRegionSelect', [function() {
      return {
        restrict: 'E',
        templateUrl: 'form-component-region-select',
        replace: true,
        scope: {
          defaultPlaceholder: '@',
          source: '=',
          model: '=',
          formObj: '=',
          formScope: '=',
          changeFunction: '=?',
          selectName: '=?',
          isVisible: '=?',
          isRequired: '=?'
        },
        bindToController: true,
        controllerAs: 'vm',
        link: function() {},
        controller: [function() {
          var self = this;

          if (! self.defaultPlaceholder) {
            self.defaultPlaceholder = 'Select a Region*';
          }
          if (typeof self.changeFunction === 'undefined') {
            self.changeFunction = function() {};
          }
          if (typeof self.selectName === 'undefined') {
            self.selectName = 'community_select';
          }
          if (typeof self.isVisible === 'undefined') {
            self.isVisible = false;
          }
          if (typeof self.isRequired === 'undefined') {
            self.isRequired = false;
          }
        }]
      };

    }]);
}());